import { Controller } from '@hotwired/stimulus';

import IMask from 'imask';

export default class CurrencyMaskController extends Controller {
    connect() {
        const mask = IMask(this.element, {
            mask:               Number,
            scale:              0,
            signed:             false,
            thousandsSeparator: '.',
            radix:              ',',
            mapToRadix:         [','],
            normalizeZeros:     true,
            padFractionalZeros: false,
            min:                0,
        });
    }
}
